import { FormLabel, Grid, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useProyecto } from "../../../data/ProyectoContext";

const AdaptacionesCurricularesABP = () => {
  const { proyecto, setProyecto } = useProyecto();

  const handleAdaptacionesCurricularesABP = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    setProyecto({ ...proyecto, adaptaciones_curriculares: value });
  };

  return (
    <Grid item xs={12}>
      <Typography
        sx={{
          color: "#336B87",
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
        }}
      >
        Adaptaciones curriculares
      </Typography>
      <FormLabel
        component="p"
        sx={{
          fontFamily: "montserrat",
          m: 0,
          pb: 2,
          fontSize: "0.85rem",
        }}
      >
        Detalla las necesidades educativas y características específicas de
        estudiantes que requieran ajustes y apoyos específicos que deben ser
        consideradas
      </FormLabel>
      <TextField
        required
        id="contexto"
        placeholder="Escribe aquí los ajustes y apoyos requeridos. Ejemplo: Una estudiante con dislexia"
        name="contexto"
        fullWidth
        autoComplete="given-name"
        variant="outlined"
        value={proyecto.adaptaciones_curriculares}
        onChange={handleAdaptacionesCurricularesABP}
        InputProps={{
          sx: {
            borderRadius: 2,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#336B87",
            "&::placeholder": {
              color: "#336B87",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

export default AdaptacionesCurricularesABP;
